/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useMemo } from 'react';
import { Route, Switch, Redirect } from 'react-router';
import { useSelector } from 'react-redux';
import { PRODUCT_ARTICLE_SENTIMENT } from '../../../state/thunks/account';
// import { PrivateRoute } from '@insticator/insticator-ui';
// material
import { Division } from '@insticator/insticator-ui'; // iui-material
// pages
import ConfigurationPage from './configuration/configuration';
import GetCodePage from './getcode/getcode';
import AdvancedPage from './advanced/advanced';
// styles
import injectSheet from 'react-jss';
import styles from './engagement_styles';



/* ========== ~~~~~~~~~~ ENGAGEMENT DIVISION ~~~~~~~~~~ ========== */
const EngagementDivision = (props) => {
  const { engagement: { accountProducts }, session: { mocked } } = useSelector((state) => state);

  const hasArticleSentimentAccess = useMemo(() =>
    accountProducts.includes(PRODUCT_ARTICLE_SENTIMENT)
  , [accountProducts]
  )

   return (
    <Division name={`engagement`} klass={props.classes.engagement}>
        <Switch>
            {/*Routes to subsections*/}
            <Route exact path='/dashboard/trendsandreactions' component={ConfigurationPage} />
            {/*<Route path='/dashboard/engagement/analytics' component={AnalyticsPage} />*/}
            <Route path='/dashboard/trendsandreactions/getcode' component={GetCodePage} />
            <Route path='/dashboard/trendsandreactions/configuration' component={ConfigurationPage} />
            <Route path='/dashboard/trendsandreactions/advanced' render={() => mocked && hasArticleSentimentAccess ? <AdvancedPage /> : <Redirect to={'/error/403'} />} />
            <Redirect to='/error/404' />
        </Switch>
    </Division>
  )
}

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(EngagementDivision);

